export enum PropertyDefTypes {
  BEHAVIOR = 'Behavior Property',
  PLAUSI = 'Plausi Property',
  CONNECTION = 'Connection Property'
}
